module.exports = "pegasus/assets/tech/email1-gallery-img1.png";